import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getProject } from '../api/Projects'
import AFrameViewer from '../aframe/AFrameViewer'
import { Splash } from './Splash'
import { Permissions } from './permissions/Permissions'
import { ErrorToast } from './ErrorToast'

function Viewer({ match }) {
    const stage = match.params.stage || 'prod'
    const qs = useLocation().search
    const query = useMemo(() => new URLSearchParams(qs), [qs])

    const projectId = useMemo(() => {
        const idInPath = match.params.projectId
        const idInQueryString = query.get('id')

        if (idInPath === 'clip' && !!idInQueryString) {
            return idInQueryString
        }
        return idInPath
    }, [match, query])

    const [status, setStatus] = useState('loading')
    const [project, setProject] = useState()
    const [previewFetchMs, setPreviewFetchMs] = useState(0)

    const delay = async () => {
        return new Promise((resolve, _) => {
            setTimeout(() => {
                resolve()
            }, 1500)
        })
    }

    useEffect(() => {
        setStatus('loading')
        const fetchStart = performance.now()
        getProject(projectId, stage)
            .then((project) => {
                setPreviewFetchMs(performance.now() - fetchStart)
                if (project.title) {
                    document.title = project.title
                }
                setProject(project)
                setStatus('brand')

                return delay()
            })
            .then(() => {
                setStatus('loaded')
            })
            .catch((error) => {
                console.error('[Viewer] Failed to load project:', error)
                setStatus('error')
            })
    }, [projectId, stage])

    if (status === 'loading' || !project) {
        return <Splash variant="project" />
    }

    if (status === 'brand' && project) {
        return <Splash project={project} />
    }

    if (status === 'missing-permissions') {
        return <Permissions />
    }

    if (status === 'error') {
        return (
            <>
                <Splash variant="project" showSlowConnectionMessage={false} />
                <ErrorToast message="This experience couldn't be loaded. Please try reloading the page." />
            </>
        )
    }

    return (
        <AFrameViewer
            project={project}
            projectId={projectId}
            previewFetchMs={previewFetchMs}
            onMissingPermissions={() => setStatus('missing-permissions')}
        />
    )
}

export default Viewer
